<template>
  <datatable :type="'orders'" :row-data="orders" :loading-message="loadingMessage" :no-rows-message="noRowsMessage" :columns="columns"></datatable>
</template>

<script>
import datatable from "datatables/datatable";

export default {
  name: "c_all_orders",
  components: {
    datatable,
    'linkComponent': {
      name: 'linkComponent',
      data() {
        return {
          web_url: process.env.MIX_WEBSITE_URL
        }
      },
      template: '<a class="view_contract_link" :href="web_url + \'company/order?id=\' + params.data.order_id" target="_blank">View</a>'
    }
  },
  data() {
    return {
      company_id: null,
      orders: null,
      loadingMessage: 'Loading All Orders...',
      noRowsMessage: 'No Orders Found',
      columns: [
        {headerName: 'Link', field: 'link', minWidth: 85, filter: false, cellRendererFramework: 'linkComponent', pinned: 'left'},
        {headerName: 'Order Ref', field: 'order_ref', width: 120, suppressSizeToFit: true, pinned: 'left'},
        {headerName: 'Date of Order', minWidth: 135, valueGetter: this.date_of_order_value_getter},
        {headerName: 'Order Created', minWidth: 140, valueGetter: this.order_created_value_getter},
        {headerName: 'Status', field: 'rel_order_progress.order_progress_status', minWidth: 100},
        {headerName: 'Signed', minWidth: 100, valueGetter: this.order_signed_value_getter},
        {headerName: 'Job Published', minWidth: 150, valueGetter: this.order_published_getter, cellStyle: { 'justify-content': "center" }},
        {headerName: 'Location', field: 'rel_order_location.job_address_full', minWidth: 160},
        {headerName: 'Position', field: 'rel_order_position.job_title', minWidth: 160},
        {headerName: 'Main Contractor', field: 'rel_order_location.site_main_contractor', minWidth: 120},
        {headerName: 'Quantity', field: 'workers_required', minWidth: 100},
        {headerName: 'Assigned', minWidth: 100, valueGetter: this.assigned_value_getter},
        {headerName: 'Start Date', minWidth: 100, valueGetter: this.start_date_value_getter},
        {headerName: 'End Date', minWidth: 100, valueGetter: this.end_date_value_getter},
        {headerName: 'Consultant', minWidth: 200, valueGetter: this.consultant_name_vg}
      ]
    }
  },
  mounted() {
    this.get_orders();
  },
  methods: {
    consultant_name_vg(params) {
      return params.data.order.consultant.first_name + ' ' + params.data.order.consultant.surname;
    },
    date_of_order_value_getter(params) {
      return this.$options.filters.formatDate(params.data.order.date_of_order);
    },
    order_created_value_getter(params) {
      return this.$options.filters.formatDateTime(params.data.created_at);
    },
    assigned_value_getter(params) {
      if (params.data.rel_assignments.length > 0) {
        let temp = params.data.rel_assignments.filter(obj => obj.assigned === true)
        return temp.length;
      }
      else {
        return 0;
      }
    },
    start_date_value_getter(params) {
      return this.$options.filters.formatDate(params.data.rel_order_position.start_date)
    },
    order_published_getter(params) {
      return params.data.order_published ? 'YES' : 'NO';
    },
    end_date_value_getter(params) {
      return this.$options.filters.formatDate(params.data.rel_order_position.end_date)
    },
    order_signed_value_getter(params) {
      return params.data.rel_order_progress.order_signed ? 'Signed' : 'Un-Signed';
    },
    get_orders() {
      axios.get(this.crmApiPath + 'contact/' + this.$store.state.auth.me.contact_id + '/company/show').then(company => {
        this.company_id = company.data.id;
        // this.orders = [];

        axios.get(this.crmApiPath + 'order/job/company/index/' + company.data.id).then(company_orders => this.orders = company_orders.data)
      });
    }
  }
}
</script>
